// Campus photo for /colleges/university-of-florida: CC BY 2.0, by Kate Haskell from Gainesville, USA, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACentury_Tower_(University_of_Florida).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-florida/; credited under the photo.
const photo = {
    "slug": "university-of-florida",
    "alt": "Century Tower, a red brick bell tower, rising above trees on the University of Florida campus in Gainesville",
    "src": "/colleges/university-of-florida/campus-1600.webp",
    "srcSmall": "/colleges/university-of-florida/campus-800.webp",
    "srcMid": "/colleges/university-of-florida/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-florida/og.jpg",
    "title": "Century Tower (University of Florida)",
    "author": "Kate Haskell from Gainesville, USA",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACentury_Tower_(University_of_Florida).jpg",
    "read": "2026-10-01"
};

export default photo;
